window.KiLocalStorage = {
    setItem: function (key, value) {
        localStorage.setItem(key, value);
    },
    getItem: function (key) {
        return localStorage.getItem(key);
    },
    removeItem: function (key) {
        localStorage.removeItem(key);
    },
    getAllKeys: function(): string[] {
        const keys:string[] = [];

        for (let i = 0; i < localStorage.length; i++) {
            const keyString: string | null = localStorage.key(i);
            if(keyString === null || keyString === undefined) { continue;}
            keys.push(keyString);
        }

        return keys;
    }
}